import React, { useState, useEffect, useRef } from "react";
import "./MiniPlayer.css";

function MiniPlayer({ playerState, onExpand, onClose }) {
  const [isPlaying, setIsPlaying] = useState(playerState?.isPlaying || false);
  const [currentTime, setCurrentTime] = useState(playerState?.currentTime || 0);
  const audioRef = useRef(null);

  const audiobook = playerState?.audiobook;
  const currentChapter = playerState?.currentChapter || 0;
  const duration = playerState?.duration || 0;

  useEffect(() => {
    if (playerState) {
      setIsPlaying(playerState.isPlaying);
      setCurrentTime(playerState.currentTime);
    }
  }, [playerState]);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio || !audiobook?.chapters?.[currentChapter]?.listenUrl) return;

    audio.src = audiobook.chapters[currentChapter].listenUrl;
    audio.currentTime = currentTime;

    if (isPlaying) {
      audio.play().catch(console.error);
    }

    const handleTimeUpdate = () => {
      setCurrentTime(audio.currentTime);
    };

    audio.addEventListener('timeupdate', handleTimeUpdate);
    return () => audio.removeEventListener('timeupdate', handleTimeUpdate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audiobook, currentChapter]);

  const togglePlay = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play().catch(console.error);
    }
    setIsPlaying(!isPlaying);
  };

  const formatTime = (seconds) => {
    if (!seconds || isNaN(seconds)) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  if (!audiobook) return null;

  const progress = duration > 0 ? (currentTime / duration) * 100 : 0;

  return (
    <div className="miniPlayer">
      <audio ref={audioRef} />

      {/* Progress bar */}
      <div
        className="miniPlayer__progress"
        style={{ '--progress': `${progress}%` }}
      />

      <div className="miniPlayer__content">
        {/* Cover */}
        <div className="miniPlayer__cover" onClick={onExpand}>
          {audiobook.coverUrl ? (
            <img src={audiobook.coverUrl} alt={audiobook.title} />
          ) : (
            <div className="miniPlayer__cover-placeholder">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
              </svg>
            </div>
          )}
        </div>

        {/* Info */}
        <div className="miniPlayer__info" onClick={onExpand}>
          <span className="miniPlayer__title">{audiobook.title}</span>
          <span className="miniPlayer__chapter">
            {audiobook.chapters?.[currentChapter]?.title || `Capítulo ${currentChapter + 1}`}
          </span>
        </div>

        {/* Time */}
        <span className="miniPlayer__time">
          {formatTime(currentTime)}
        </span>

        {/* Controls */}
        <div className="miniPlayer__controls">
          <button className="miniPlayer__play" onClick={togglePlay}>
            {isPlaying ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 5v14l11-7z"/>
              </svg>
            )}
          </button>

          <button className="miniPlayer__close" onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

export default MiniPlayer;
